import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';
import { CdwButtonModule } from '@cdw-ae/common-ui-components-button';
import { CdwCheckboxModule } from '@cdw-ae/common-ui-components-checkbox';
import { CdwDividerModule } from '@cdw-ae/common-ui-components-divider';
import { CdwMessageBandModule } from '@cdw-ae/common-ui-components-message-band';
import { CommonUiComponentsTextInputModule } from '@cdw-ae/common-ui-components-text-input';

import { CdwRoleEditComponent } from './cdw-role-edit/cdw-role-edit.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialLibraryModule,
    CommonUiComponentsTextInputModule,
    CdwMessageBandModule,
    CdwButtonModule,
    CdwDividerModule,
    CdwCheckboxModule,
    CdwRoleEditComponent,
    ReactiveFormsModule,
    FormsModule,
  ],
  declarations: [],
  exports: [CdwRoleEditComponent],
})
export class CdwRoleEditModule {}
